import React, { useEffect, useRef, useState } from "react";
import { Avatar, Button, Flex, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { CallAcceptIcon, HangupIcon } from "../../icons";
import {
  acceptGroupCall,
  rejectGroupCall,
} from "../../../redux/slices/sipSlice";
import { useSocket } from "../../../context/SocketContext";
import "./index.scss";

const { Text } = Typography;

export const useAppDispatch: () => AppDispatch = useDispatch;

const IncomingGroupCall: React.FC = () => {
  const dispatch = useAppDispatch();
  const { socket } = useSocket();
  const { callerId } = useSelector((state: RootState) => state.sip);
  const [incomgingGrpCallDetails, setIncomingGrpCallDetails] =
    useState<any>(null);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const rejectCall = () => {
    dispatch(
      rejectGroupCall({
        sourceNumber: callerId || "",
        uuid: incomgingGrpCallDetails?.callUUID,
        groupId: incomgingGrpCallDetails?.groupId,
        groupName: incomgingGrpCallDetails?.groupName,
        callerName: incomgingGrpCallDetails?.groupCallInitFullName,
        callerId: incomgingGrpCallDetails?.groupCallInitUserId,
      })
    );
    setIncomingGrpCallDetails(null);
  };

  useEffect(() => {
    socket?.on("groupCallInvite", (message) => {
      setIncomingGrpCallDetails(message);
    });

    return () => {
      socket?.off("groupCallInvite", () => {
        setIncomingGrpCallDetails(null);
      });
    };
  }, [socket]);

  useEffect(() => {
    if (incomgingGrpCallDetails) {
      if (!audioRef.current) {
        audioRef.current = new Audio("/sounds/ringtone.mp3");
        audioRef.current.loop = true;
      }
      audioRef.current.play().catch((err) => {
        console.warn("Ringtone autoplay blocked by browser:", err);
      });
    } else {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    }
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    };
  }, [incomgingGrpCallDetails]);

  if (!incomgingGrpCallDetails) return null;

  return (
    <div className="incoming-grp-call-wrapper">
      <Flex justify="space-between" align="center" style={{ width: "100%" }}>
        <Flex align="center" gap={10}>
          <Avatar className={`avatar efone-avatar`}>
            <Text className="user-initial">GC</Text>
          </Avatar>
          <div style={{ fontWeight: "bold", fontSize: 16 }}>
            {incomgingGrpCallDetails?.callername}
            <span className="ringing-text"> Incoming Group Call...</span>
          </div>
        </Flex>

        <Flex gap={12}>
          <Button
            type="primary"
            className="call-accept-btn"
            shape="circle"
            size="large"
            icon={<CallAcceptIcon />}
            onClick={() => {
              dispatch(
                acceptGroupCall({
                  groupId: incomgingGrpCallDetails?.groupId,
                  uuid: incomgingGrpCallDetails?.uuid,
                })
              );
              setIncomingGrpCallDetails(null);
            }}
          />
          <Button
            type="primary"
            className="call-hangup-btn"
            shape="circle"
            size="large"
            icon={<HangupIcon />}
            onClick={rejectCall}
          />
        </Flex>
      </Flex>
    </div>
  );
};

export default IncomingGroupCall;
